export default __webpack_public_path__ + "static/media/cursor.c9171346.svg";